import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Table, Select, Radio } from "antd";
import { ResponsiveLine } from '@nivo/line'
import { ResponsiveBar } from '@nivo/bar'
import ProgressModal from '../../../App/Utils/ProgressModal'
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import SupplierSearchBox from "../../../Components/SupplierSearchBox";
import { DataProvider } from "../../DataProvider";
import { FEEDBACK_REPORT_COLUNMN_DEFS, FEEDBACK_SCORE_CARD_COLUNMN_DEFS } from "../../Constants";
import MonthlyReport from "./Components/MonthlyReport";
import ScoreCardReport from "./Components/ScoreCardReport";
import QuarterlyReport from "./Components/QuarterlyReport";

var _ = require('lodash');

const FeedbackReport = (props) => {
    const [mode, setMode] = useState('report')

    return (
        <>
            <Radio.Group
                onChange={e=>{
                    setMode(e.target.value)
                }}
                value={mode}
                style={{marginLeft:"10px"}}
            >
                <Radio.Button value="report">Monthly</Radio.Button>
                <Radio.Button value="quarterly">Quarterly</Radio.Button>
                <Radio.Button value="scorecard">Score Card</Radio.Button>
            </Radio.Group>
            {mode=='report'?
                <MonthlyReport />:
                mode=='quarterly'?
                <QuarterlyReport />:
                <ScoreCardReport />
            }

        </>

    );
};

export default FeedbackReport;
